<form [formGroup]="penFormGroup">
  <div class="flex--column">
    <h3>{{ 'fecal-scoring.detail.pen' | translate }} {{ index + 1 }}</h3>
    <mat-form-field class="flex__child--auto spacing--margin-top penage">
      <mat-label>{{ 'fecal-scoring.detail.label.age' | translate }}</mat-label>
      <input
        matInput
        formControlName="fecalScoringAge"
        placeholder="{{ 'fecal-scoring.detail.label.name' | translate }}"
        data-test="fecal-scoring-detail__age"
      />
      <span matTextSuffix class="form-field-suffix--text">{{
        'fecal-scoring.detail.label.days' | translate
      }}</span>
      <mat-error *ngIf="penFormGroup.controls.fecalScoringAge.invalid">
        {{ 'fecal-scoring.detail.error-age' | translate }}</mat-error
      >
    </mat-form-field>
  </div>

  <div>
    <app-fecal-scoring-detail-pen-score-form
      [penScoreFormGroup]="penFormGroup.controls.penScore.value"
      [isMobile]="isMobile"
    >
    </app-fecal-scoring-detail-pen-score-form>
  </div>
  <div class="flex--column spacing--margin-bottom deletebutton">
    <button
      *ngIf="canDelete"
      mat-flat-button
      color="primary"
      color="warn"
      (click)="delete()"
      data-test="create-fecal-scoring__delete-pen"
    >
      <mat-icon>delete</mat-icon>{{ 'fecal-scoring.detail.delete-pen' | translate }}
    </button>
  </div>
</form>
